import { useEffect, useState } from "react";

import Typography from "@/foundation/Typography/V2";

import {
  clsx,
  classNameGenerator,
  getTimeDifferenceFromNow,
  isDateInPast,
} from "@/utils";

import styles from "./OfferCountdown.module.scss";
import { SVGSprite } from "@/components/Atoms";

interface OfferCountdownProps {
  label?: string;
  endDate: string;
  className?: string;
  icon?: string
}

const OfferCountdown: React.FC<OfferCountdownProps> = ({
  label,
  endDate,
  className,
  icon
}) => {
  const cls = classNameGenerator(styles);

  const [isDateHasPassed, setIsDateHasPassed] = useState(isDateInPast(endDate));

  const [countdown, setCountdown] = useState(getTimeDifferenceFromNow(endDate));

  useEffect(() => {
    const interval = setInterval(() => {
      const timeObject = getTimeDifferenceFromNow(endDate);
      setIsDateHasPassed(timeObject?.seconds < 0);
      setCountdown(timeObject);
    }, 1000);

    return () => clearInterval(interval);
  }, [endDate]);

  if (isDateHasPassed) {
    return <></>;
  }

  return (
    <div className={clsx(cls("offerCountdown"), className)}>
      <div className={cls("topSection")}>
        {icon ?
          <SVGSprite
            icon={icon}
            className={cls("icon")}
          />
          : OfferIcon
        }
        {label && <Typography variant="paragraph4" className={cls("label")}>
          {label}
        </Typography>}
      </div>
      <div className={cls("offerTextContainer")}>
        <div className={cls("timeContainer")}>
          <span className={cls("time")}>{countdown.days}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            days
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("time")}>{countdown.hours}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            h :
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("time")}>{countdown.minutes}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            m :
          </Typography>
        </div>
        <div className={cls("timeContainer")}>
          <span className={cls("time")}>{countdown.seconds}</span>
          <Typography variant="paragraph4" className={cls("timeLabel")}>
            s left
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default OfferCountdown;

const OfferIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5289 10.87L20.0089 9.35001C19.7489 9.09 19.5389 8.58001 19.5389 8.22001V6.06C19.5389 5.18 18.8189 4.46 17.9389 4.46H15.7889C15.4289 4.46 14.9189 4.25 14.6589 3.99L13.1389 2.47C12.5189 1.85 11.4989 1.85 10.8789 2.47L9.33891 3.99C9.08891 4.25 8.57891 4.46 8.20891 4.46H6.05891C5.17891 4.46 4.45891 5.18 4.45891 6.06V8.21C4.45891 8.57 4.24891 9.08 3.98891 9.34L2.46891 10.86C1.84891 11.48 1.84891 12.5 2.46891 13.12L3.98891 14.64C4.24891 14.9 4.45891 15.41 4.45891 15.77V17.92C4.45891 18.8 5.17891 19.52 6.05891 19.52H8.20891C8.56891 19.52 9.07891 19.73 9.33891 19.99L10.8589 21.51C11.4789 22.13 12.4989 22.13 13.1189 21.51L14.6389 19.99C14.8989 19.73 15.4089 19.52 15.7689 19.52H17.9189C18.7989 19.52 19.5189 18.8 19.5189 17.92V15.77C19.5189 15.41 19.7289 14.9 19.9889 14.64L21.5089 13.12C22.1589 12.51 22.1589 11.49 21.5289 10.87ZM7.99891 9C7.99891 8.45 8.44891 8 8.99891 8C9.54891 8 9.99891 8.45 9.99891 9C9.99891 9.55 9.55891 10 8.99891 10C8.44891 10 7.99891 9.55 7.99891 9ZM9.52891 15.53C9.37891 15.68 9.18891 15.75 8.99891 15.75C8.80891 15.75 8.61891 15.68 8.46891 15.53C8.17891 15.24 8.17891 14.76 8.46891 14.47L14.4689 8.47001C14.7589 8.18001 15.2389 8.18001 15.5289 8.47001C15.8189 8.76 15.8189 9.24 15.5289 9.53L9.52891 15.53ZM14.9989 16C14.4389 16 13.9889 15.55 13.9889 15C13.9889 14.45 14.4389 14 14.9889 14C15.5389 14 15.9889 14.45 15.9889 15C15.9889 15.55 15.5489 16 14.9989 16Z"
      fill="#D92D20"
    />
  </svg>
);
